import React, { Component } from "react";
import { Card, FlatButton, Divider, CardTitle } from "material-ui";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import FilterIndex from "../FilterIndex";

export default class ClientIndex extends Component {
  constructor(props) {
    super(props);

    this.renderTable = this.renderTable.bind(this);
    this.viewButton = this.viewButton.bind(this);
  }

  viewButton(cell, row) {
    let url = `/job/salesForceClients/clientEditor/${cell}`;
    return (
      <FlatButton
        label="View"
        backgroundColor="#E0E0E0"
        hoverColor="#BDBDBD"
        onClick={this.props.performRoute.bind(this, url)}
      />
    );
  }

  renderTable() {
    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let filter = { type: "TextFilter", delay: 500 };
      return (
        <div>
          <BootstrapTable data={this.props.workOrders} pagination>
            <TableHeaderColumn
              dataField="uid__c"
              filter={filter}
              dataSort
              isKey
              width="125"
            >
              ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              dataSort
              filter={filter}
              dataFormat={this.linkFormatter}
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="primary_email__c"
              dataSort
              filter={filter}
            >
              Email
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="phone"
              dataSort
              filter={filter}
              width="200"
            >
              Phone
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="_id"
              dataFormat={this.viewButton}
              width="100"
            ></TableHeaderColumn>
          </BootstrapTable>
        </div>
      );
    }
  }

  render() {
    return (
      <Card
        className="container"
        zDepth={2}
        style={{ marginTop: "2em", padding: "2em 7em 0em 7em" }}
      >
        <CardTitle title="Clients" />
        <Divider style={{ margin: "1em 1em" }} />
        <FilterIndex url="clients" filterKey="record_type__c" {...this.props} />
        <br />
        {this.renderTable()}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/clients/ClientIndex.js